import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TransferActivityModal from "./TransferActivityModal";
import ExtendActivityModal from "./ExtendActivityModal";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";

// Adding new tooltip
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional
import {
  RESET_PERFORMANCE_STATE,
  RESET_SAVE_TEMPORARY_DATA,
} from "../../redux/constants";
import PageSelector from "../PageSelector";
import useDebounce from "../../Hook/useDebounce";
import { getBookingFieldList } from "../../redux/actions/booking";
import {
  getCustomizedTableColumnsData,
  addOrEditCustomizedTableColumns,
} from "../../redux/actions/customizedTable";
import RowsPerPageSelector from "../RowsPerPageSelector";

// Draggable Table
import { DraggableTable } from "../../component/table";
import { ToggleFilter } from "../../component/Filter/CheckboxFilter";
import {
  Super_Admin,
  Admin,
  Collaborator,
  Customer,
} from "../../constant/AuthenticationConstant";

const RecentActivities = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Creating state for option
  const [isExtend, setIsExtend] = useState(false);
  const [isTransfer, setIsTransfer] = useState(false);

  // Function to handle onChange event
  const [current_id, set_current_id] = useState();
  const [status, set_status] = useState();
  const [mapping_id, set_mapping_id] = useState();
  const [activityId, set_activity_id] = useState();
  const [activity_assignment_id, set_activity_assignment_id] = useState();
  const { overviewData, searchText, groupedByFilter } = useSelector(
    (state) => state.overview
  );
  const user = useSelector((state) => state.auth);
  const { tempPageName } = useSelector((state) => state.tempWindowsData);

  // State for table
  const [page, setPage] = useState(1);
  const [currentPageWhileSearching, setCurrentPageWhileSearching] = useState(1);

  // Check if both company_id and email are present to determine embedded
  const isEmbedded = Boolean(props.company_id && props.email);
  const isCustomerOrCollaborator = ["customer", "collaborator"].includes(
    user.type
  );

  /* ------------------- Draggable Data Table ----------------------- */

  const { bookingFieldList } = useSelector((state) => state.booking);
  const { customized_columns_overview } = useSelector(
    (state) => state.customizedTable
  );
  const [data, setData] = useState(() => []);
  const [toggleData, setToggleData] = useState({
    General: [
      {
        label: "To Do",
        value: "activity_name",
        checked: true,
        size: 200,
      },
      {
        label: "Booking ID",
        value: "job_id",
        checked: true,
        size: 200,
      },
      {
        label: "End Date",
        value: "estimated_time",
        checked: true,
        size: 200,
      },
      {
        label: "Status",
        value: "status",
        checked: true,
        size: 200,
      },
      {
        label: "Vendor",
        value: "vendor_name",
        checked: false,
        size: 200,
      },
      {
        label: "Customer",
        value: "customer",
        checked: false,
        size: 200,
      },
    ],
  });
  const [columns, setColumns] = useState([]);
  const [columnOrder, setColumnOrder] = useState([]);
  const [isTableChange, setIsTableChange] = useState(0);

  const handleChange = (
    value,
    activity_assignment_id,
    assignment_id,
    status,
    assignment_mapping_id,
    activity_id
  ) => {
    set_activity_id(activity_id);
    set_current_id(assignment_id);
    set_mapping_id(assignment_mapping_id);
    set_activity_assignment_id(activity_assignment_id);
    if (value === "Perform activity") {
      if (isEmbedded) {
        navigate(
          `/activity/performance/embedded/${props.company_id}/${activity_assignment_id}/${props.email}?activity_id=${activity_id}`
        );
      } else {
        dispatch({ type: RESET_PERFORMANCE_STATE });
        navigate(
          `/todo/performance/${activity_assignment_id}?activity_id=${activity_id}`
        );
      }
    } else if (value === "Extend activity") {
      setIsExtend(true);
      set_status(status);
    } else if (value === "Transfer activity") {
      setIsTransfer(true);
    }
  };

  // Use the debounce hook to get the debounced version of the handleSearch function
  const debouncedHandleSearch = useDebounce(searchText, 1000);

  useEffect(() => {
    if (debouncedHandleSearch) {
      // User is searching and currentPageWhileSearching is not set, store the current page
      if (currentPageWhileSearching === null) {
        setCurrentPageWhileSearching(page);
      }
      props.onPageChange(1);
      setPage(1);
      props.setDebouncedSearchText(debouncedHandleSearch);
    } else {
      // User removed search text, revert to the stored current page if it exists
      if (currentPageWhileSearching !== null) {
        props.onPageChange(currentPageWhileSearching);
        setPage(currentPageWhileSearching);
        setCurrentPageWhileSearching(null); // Reset currentPageWhileSearching
      }
      props.setDebouncedSearchText(debouncedHandleSearch);
    }
  }, [debouncedHandleSearch]);

  const getStatusStyles = (status, endDate) => {
    switch (status) {
      case "completed":
      case "completed with delay":
        return {
          className:
            "w-4 h-4 border-3 rounded-full border-[--bg-color-500] bg-[--bg-color-500]",
          innerDiv: null,
        };
      case "pending":
        return {
          className: "w-4 h-4 border-3 rounded-full border-[--bg-color-500]",
          innerDiv: null,
        };
      case "in progress":
        const isOverdueInprogress = moment().isAfter(endDate, "date");
        const commonStyles = "w-4 h-4 border-3 rounded-full relative";

        return {
          className: `${commonStyles} ${
            isOverdueInprogress ? "border-[#D31313]" : "border-[--bg-color-500]"
          }`,
          innerDiv: (
            <div
              className={`absolute top-0 left-0 w-1/2 h-full ${
                isOverdueInprogress ? "bg-[#D31313]" : "bg-[--bg-color-500]"
              } rounded-l-full border-0`}
            ></div>
          ),
        };
      case "overdue":
      case "overdue in progress":
        return {
          className: "w-4 h-4 border-3 rounded-full border-[#D31313]",
          innerDiv: null,
        };
      default:
        return {
          className: "w-4 h-4 border-3 rounded-full border-grey-500",
          innerDiv: null,
        };
    }
  };

  const statusTextColor = (status, endDate) => {
    switch (status) {
      case "completed":
      case "completed with delay":
        return "text-[--bg-color-500]";
      case "pending":
        return "text-[--bg-color-500]";
      case "in progress":
        const isOverdueInprogress = moment().isAfter(endDate, "date");

        return isOverdueInprogress ? "text-[#D31313]" : "text-[--bg-color-500]";
      case "overdue":
      case "overdue in progress":
        return "text-[#D31313]";
      default:
        return "text-grey-500";
    }
  };

  const renderStatus = (status, endDate) => {
    const { className, innerDiv } = getStatusStyles(status, endDate);
    return (
      <>
        <div>
          <div className={className}>{innerDiv}</div>
        </div>
        <p
          // title={status === "completed with delay" ? "completed" : status}
          title={status}
          className={`pl-2 text-sm font-normal tracking-tight leading-3 capitalize ${statusTextColor(
            status,
            endDate
          )} max-w-1/2 truncate`}
        >
          {/* {status === "completed with delay" ? "completed" : status} */}
          {status}
        </p>
      </>
    );
  };

  const handleHeaderClick = (sort_by) => {
    if (props.sortField === sort_by && props.sortOrder === "asc") {
      props.setSortOrder("desc");
      props.setSortField(sort_by);
    } else {
      props.setSortOrder("asc");
      props.setSortField(sort_by);
    }
  };

  // Function to call API to get booking field
  const getBookingFieldListData = () => {
    dispatch(getBookingFieldList());
  };

  // function to call API to get customized columns data added by user
  const getCustomizedTableColumns = () => {
    const request = {
      type: "dashboard",
    };
    dispatch(getCustomizedTableColumnsData(request));
  };

  // Function to display table header and sort functionality
  const headerWithSort = (headerName, sort_by, isSort) => {
    return (
      <div>
        <span
          className="cursor-pointer"
          onClick={() => {
            console.log('column click ==>', isSort)
            if (isSort) {
              handleHeaderClick(sort_by);
            }
          }}
        >
          {headerName}
        </span>
        {isSort &&
          !toggleData["Booking Data"]?.some(
            (item) => item.label === headerName
          ) && (
            <svg
              width="12"
              height="16"
              viewBox="0 0 8 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="inline ml-2 -mt-[2px]"
            >
              <path
                d="M6.82673 4.88075C6.69853 4.8809 6.57156 4.85571 6.45312 4.80662C6.33468 4.75754 6.22711 4.68553 6.13659 4.59474L3.89826 2.35647L1.65994 4.59474C1.47634 4.77505 1.22896 4.87555 0.971628 4.87439C0.714298 4.87322 0.46784 4.77048 0.285878 4.58852C0.103916 4.40655 0.00117537 4.1601 1.00221e-05 3.90277C-0.00115533 3.64544 0.0993491 3.39806 0.279655 3.21446L3.20812 0.285989C3.29874 0.195323 3.40633 0.1234 3.52476 0.0743293C3.64318 0.0252584 3.77011 0 3.89829 0C4.02648 0 4.15341 0.0252584 4.27183 0.0743293C4.39026 0.1234 4.49785 0.195323 4.58847 0.285989L7.51693 3.21446C7.65341 3.35098 7.74635 3.5249 7.784 3.71423C7.82164 3.90356 7.80231 4.09981 7.72843 4.27816C7.65456 4.4565 7.52947 4.60894 7.36897 4.7162C7.20847 4.82346 7.01977 4.88072 6.82673 4.88075Z"
                className={`cursor-pointer fill-current ${
                  props.sortField === sort_by && props.sortOrder === "asc"
                    ? "text-[--bg-color-500]"
                    : "text-[#9C9C9C]"
                }`}
                onClick={() => {
                  props.setSortOrder("asc");
                  props.setSortField(sort_by);
                }}
              />
              <path
                d="M3.56018 11.9259C3.67862 11.975 3.80559 12.0001 3.93379 12C4.062 12.0001 4.18897 11.975 4.30741 11.9259C4.42585 11.8768 4.53342 11.8048 4.62394 11.714L7.5524 8.78552C7.73355 8.60208 7.83477 8.35444 7.83396 8.09664C7.83316 7.83884 7.73039 7.59183 7.5481 7.40953C7.36581 7.22724 7.11881 7.12446 6.86101 7.12364C6.60321 7.12283 6.35556 7.22404 6.17212 7.40517L3.93379 9.6435L1.69547 7.40523C1.51187 7.22493 1.26449 7.12442 1.00716 7.12559C0.749827 7.12675 0.503369 7.22949 0.321407 7.41145C0.139445 7.59342 0.0367045 7.83987 0.0355392 8.09721C0.0343738 8.35454 0.134878 8.60191 0.315185 8.78552L3.24365 11.714C3.33417 11.8048 3.44174 11.8768 3.56018 11.9259Z"
                className={`cursor-pointer fill-current ${
                  props.sortField === sort_by && props.sortOrder === "desc"
                    ? "text-[--bg-color-500]"
                    : "text-[#9C9C9C]"
                }`}
                onClick={() => {
                  props.setSortOrder("desc");
                  props.setSortField(sort_by);
                }}
              />
            </svg>
          )}
      </div>
    );
  };

  // Function to handle toggle change
  const handleToggleChange = (index, key) => {
    setToggleData((prevToggleData) => {
      const updatedData = { ...prevToggleData };
      updatedData[key][index].checked = !updatedData[key][index].checked;
      return updatedData;
    });
  };

  // Function to call Post API to add table changes
  const addAndUpdateCustomizableTableChange = (size) => {
    let concatenatedArr;
    if (toggleData["Booking Data"]) {
      concatenatedArr = toggleData["General"].concat(
        toggleData["Booking Data"]
      );
    } else {
      concatenatedArr = toggleData["General"];
    }

    const table_structure = columnOrder
      .slice(0, -1)
      .map((columnField, index) => {
        const isColumnAvailable = concatenatedArr.find(
          (toggleField) => toggleField.value === columnField
        );
        const obj = {
          key: isColumnAvailable.value,
          label: isColumnAvailable.label,
          sequence: index + 1,
          size:
            size && Object.keys(size).length > 0
              ? Object.keys(size).some((key) => key === isColumnAvailable.value)
                ? size[isColumnAvailable.value]
                : isColumnAvailable.size
              : isColumnAvailable.size,
        };
        return obj;
      });

    const payload = {
      type: "dashboard",
      table_structure: JSON.stringify(table_structure),
    };

    if (customized_columns_overview) {
      payload.table_layout_id = customized_columns_overview.table_layout_id;
    }

    const request = {
      payload,
    };

    dispatch(addOrEditCustomizedTableColumns(request));

    setIsTableChange(0);
  };

  useEffect(() => {
    if (user.type !== Collaborator && user.type !== Customer) {
      getBookingFieldListData();
      getCustomizedTableColumns();
    }
  }, []);

  // Use the debounce hook to get the debounced version of the columns changes in customizable table
  const debounceHandleColumnsChange = useDebounce(isTableChange, 5000);

  //  useEffect to call API to upsert columns changes in customizable table
  useEffect(() => {
    if (debounceHandleColumnsChange) {
      addAndUpdateCustomizableTableChange();
    }
  }, [debounceHandleColumnsChange]);

  // useEffect to add booking custom fields
  useEffect(() => {
    if (bookingFieldList?.length > 0) {
      const customFieldToogle = bookingFieldList.map((field) => {
        const toogleObj = {
          label: field.label,
          value: field.key,
          checked: customized_columns_overview?.table_structure
            ? JSON.parse(customized_columns_overview.table_structure).some(
                (element) => element.key === field.key
              )
            : false,
          size: customized_columns_overview?.table_structure
            ? JSON.parse(customized_columns_overview.table_structure).some(
                (element) => element.key === field.key
              )
              ? JSON.parse(customized_columns_overview.table_structure).find(
                  (element) => element.key === field.key
                ).size
              : 200
            : 200,
        };
        return toogleObj;
      });

      if (customized_columns_overview?.table_structure) {
        const table_structure_data = JSON.parse(
          customized_columns_overview.table_structure
        );
        const generalFieldToggle = toggleData["General"].map((field) => {
          const toogleObj = {
            label: field.label,
            value: field.value,
            checked: table_structure_data.some(
              (element) => element.key === field.value
            ),
            size: table_structure_data.some(
              (element) => element.key === field.value
            )
              ? table_structure_data.find(
                  (element) => element.key === field.value
                ).size
              : 200,
          };
          return toogleObj;
        });

        setToggleData({
          General: generalFieldToggle,
          "Booking Data": customFieldToogle,
        });
      } else {
        setToggleData({ ...toggleData, "Booking Data": customFieldToogle });
      }
    }
  }, [bookingFieldList, customized_columns_overview]);

  // Function to check Custome Field
  const isCustomeField = (table_column_key) => {
    return bookingFieldList.some((item) => item.key === table_column_key)
  }

  // useEffect to setting columns in table
  useEffect(() => {
    const columnsData = [];
    if (customized_columns_overview?.table_structure) {
      const table_structure_data = JSON.parse(
        customized_columns_overview.table_structure
      );

      // Added two General and Booking Data toggle fields
      let concatenatedArr;
      if (toggleData["Booking Data"]) {
        concatenatedArr = toggleData["General"].concat(
          toggleData["Booking Data"]
        );
      } else {
        concatenatedArr = toggleData["General"];
      }

      // Filter concatenatedArr
      const filterConcatenateArr = concatenatedArr.filter(
        (element) => element.checked
      );

      for (const table_column of table_structure_data) {
        if (
          filterConcatenateArr.some((item) => item.value === table_column.key)
        ) {
          columnsData.push({
            accessorKey: table_column.key,
            cell: (info) => info.getValue(),
            id: table_column.key,
            header:
              table_column.label === "Status" || groupedByFilter || isCustomeField(table_column.key)
                ? headerWithSort(table_column.label, table_column.key, false)
                : headerWithSort(table_column.label, table_column.key, true),
            size: table_column.size,
            minSize: 50,
          });
        }
      }

      const filteredNotAddedField = filterConcatenateArr.filter(
        (filterItem) =>
          !table_structure_data.some(
            (tableItem) => tableItem.key === filterItem.value
          )
      );

      // Added fields which is not in table_structure_data but it is checked by user
      if (filteredNotAddedField.length > 0) {
        for (const filteredField of filteredNotAddedField) {
          columnsData.push({
            accessorKey: filteredField.value,
            cell: (info) => info.getValue(),
            id: filteredField.value,
            header:
              filteredField.label === "Status" || isCustomeField(filteredField.value)
                ? headerWithSort(
                    filteredField.label,
                    filteredField.value,
                    false
                  )
                : headerWithSort(
                    filteredField.label,
                    filteredField.value,
                    true
                  ),
            size: filteredField.label === "Status" ? 150 : 200,
            minSize: 50,
          });
        }
      }
    } else {
      Object.keys(toggleData).map((toggleKey, index) => {
        for (const toggleVal of toggleData[toggleKey]) {
          if (toggleVal.checked) {
            columnsData.push({
              accessorKey: toggleVal.value,
              cell: (info) => info.getValue(),
              id: toggleVal.value,
              header:
                toggleKey === "Booking Data" || toggleVal.label === "Status" || isCustomeField(toggleVal.value)
                  ? headerWithSort(toggleVal.label, toggleVal.value, false)
                  : headerWithSort(toggleVal.label, toggleVal.value, true),
              size: toggleVal.label === "Status" ? 150 : 200,
              minSize: 50,
            });
          }
        }
        return null;
      });
    }

    if (isCustomerOrCollaborator) {
      columnsData.splice(2, 0, {
        accessorKey: "vendor_name",
        cell: (info) => info.getValue(),
        id: "vendor_name",
        header: headerWithSort("Vendor", "vendor_name", true),
        size: 200,
        minSize: 50,
      });
    }

    columnsData.push({
      accessorKey: "action",
      cell: (info) => info.renderValue(),
      id: "action",
      header: (
        <div className="flex items-center justify-between z-30">
          <h1 className="z-30">Action</h1>
          {user.type === Super_Admin && (
            <ToggleFilter
              toggleData={toggleData}
              handleToggleChange={handleToggleChange}
              isTableChange={isTableChange}
              setIsTableChange={setIsTableChange}
            />
          )}
        </div>
      ),
      size: 150,
      minSize: 50,
    });

    setColumns(columnsData);
  }, [props.sortField, props.sortOrder, toggleData, groupedByFilter]);

  useEffect(() => {
    if (columns.length > 0) {
      setColumnOrder(columns.map((c) => c.id));
    }
  }, [columns]);

  /* ---------------- Creating data --------------- */

  // Function to form Table Data
  const createTableData = (data) => {
    const tableData = data.map((item) => {
      const obj = {};
      obj.activity_assignment_id = item?.activity_assignment_id;
      obj.activity_id = item?.activity_id;

      const toDoName = (
        <div className="font-semibold flex items-center">
          <div
            title={item.activity_name}
            className={`${
              item.is_transfered ? "w-auto" : "w-auto"
            } overflow-hidden truncate`}
          >
            {item.activity_name}
          </div>
          {item.is_locked === 1 && (
            <span
              title=""
              className="fas fa-lock pl-1"
              style={{ color: "#8b8c8d" }}
            ></span>
          )}
          {item.is_transfered === true && (
            <span
              title=""
              className="ml-2 px-2 py-1 bg-[--bg-color-500] rounded text-white text-[10px] font-semibold"
            >
              Transferred
            </span>
          )}
          {item.is_extend_requested === true && (
            <span
              title=""
              className="ml-2 px-2 py-1 bg-[--bg-color-500] rounded text-white text-[10px] font-semibold"
            >
              Extension Requested
            </span>
          )}
        </div>
      );

      // Adding data for general table columns and adding undefined for Booking Data table column
      for (const columnData of columns) {
        if (columnData.id === "estimated_time" && !item?.super_row) {
          obj[columnData.id] = moment(item[columnData.id]).format(
            "DD MMM, YYYY - HH:mm a"
          );
        } else if (columnData.id === "activity_name" && !item?.super_row) {
          obj[columnData.id] = toDoName;
        } else {
          obj[columnData.id] = item[columnData.id];
          if (item.super_row) {
            obj["super_row"] = true;
          }
        }
      }

      // Adding data to Booking Data table component
      if (toggleData["Booking Data"]) {
        for (const bookingDataColumns of toggleData["Booking Data"]) {
          if (bookingDataColumns.checked) {
            const custom_field_val = item?.booking_controls
              ? JSON.parse(item.booking_controls).find(
                  (comp) => comp.key === bookingDataColumns.value
                )
              : "";

            obj[bookingDataColumns.value] = custom_field_val
              ? custom_field_val.value
              : "";
          }
        }
      }

      if (!item?.super_row) {
        obj.action = (
          <div className="space-x-3 flex items-center">
            <Tippy content="Perform To Do">
              {item.status === "completed" ||
              item.status === "completed with delay" ? (
                <a
                  className={`btn-sm p-2 bg-[--bg-color-500] cursor-pointer hover:bg-[--bg-color-600] w-8
               text-white flex justify-center items-center`}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleChange(
                      "Perform activity",
                      item.activity_assignment_id,
                      item.assignment_id,
                      item.status,
                      item.assignment_mapping_id,
                      item.activity_id
                    );
                  }}
                >
                  <span className="fad fa-info-circle fill-current"></span>
                </a>
              ) : (
                <a
                  className={`btn-sm p-2 bg-[--bg-color-500] cursor-pointer hover:bg-[--bg-color-600] w-8
            text-white flex justify-center items-center`}
                  onClick={() =>
                    handleChange(
                      "Perform activity",
                      item.activity_assignment_id,
                      item.assignment_id,
                      item.status,
                      item.assignment_mapping_id,
                      item.activity_id
                    )
                  }
                >
                  <span className="fad fa-calendar-check fill-current"></span>
                </a>
              )}
            </Tippy>

            {!isCustomerOrCollaborator && (
              <Tippy content="Extend To Do">
                <a
                  className={`btn-sm p-2 ${
                    item.status === "completed" ||
                    !item.is_extensible ||
                    item.is_extend_requested ||
                    item.status === "completed with delay"
                      ? "bg-slate-200 cursor-not-allowed"
                      : "bg-white cursor-pointer"
                  } text-slate-600 border-slate-200 hover:border-slate-300 w-8`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (
                      item.status === "completed" ||
                      !item.is_extensible ||
                      item.is_extend_requested ||
                      item.status === "completed with delay"
                    ) {
                      console.log("disabled extend button");
                    } else {
                      handleChange(
                        "Extend activity",
                        item.activity_assignment_id,
                        item.assignment_id,
                        item.status,
                        item.assignment_mapping_id,
                        item.activity_id
                      );
                    }
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4"
                    viewBox="0 0 576 512"
                  >
                    <path
                      className="fa-primary text-slate-300"
                      fill="currentColor"
                      d="M576 368C576 447.5 511.5 512 432 512C352.5 512 288 447.5 288 368C288 288.5 352.5 224 432 224C511.5 224 576 288.5 576 368zM416 303.1V351.1H368C359.2 351.1 352 359.2 352 367.1C352 376.8 359.2 383.1 368 383.1H416V431.1C416 440.8 423.2 447.1 432 447.1C440.8 447.1 448 440.8 448 431.1V383.1H496C504.8 383.1 512 376.8 512 367.1C512 359.2 504.8 351.1 496 351.1H448V303.1C448 295.2 440.8 287.1 432 287.1C423.2 287.1 416 295.2 416 303.1z"
                    />
                    <path
                      className="fa-secondary"
                      fill="currentColor"
                      d="M96 32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V160H0V112C0 85.49 21.49 64 48 64H96V32zM416 192.7C326.3 200.8 256 276.2 256 368C256 427.5 285.6 480.1 330.8 512H48C21.49 512 0 490.5 0 464V192H416V192.7z"
                    />
                  </svg>
                </a>
              </Tippy>
            )}

            {!isCustomerOrCollaborator && (
              <Tippy content="Transfer To Do">
                <a
                  className={`btn-sm p-2 ${
                    item.status === "completed" ||
                    item.status === "completed with delay"
                      ? "bg-slate-200 cursor-pointer"
                      : "bg-white cursor-pointer"
                  } text-slate-600 border-slate-200 hover:border-slate-300 w-8`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (
                      item.status !== "completed" &&
                      item.status !== "completed with delay"
                    ) {
                      handleChange(
                        "Transfer activity",
                        item.activity_assignment_id,
                        item.assignment_id,
                        item.status,
                        item.assignment_mapping_id,
                        item.activity_id
                      );
                      if (tempPageName === "Transfer To Do") {
                        dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
                      }
                    }
                  }}
                >
                  <span className="fad fa-exchange fill-current"></span>
                </a>
              </Tippy>
            )}
          </div>
        );
        obj.status = (
          <div className={`flex items-center`}>
            {renderStatus(item.status, item.endDate)}
          </div>
        );
      }

      return obj;
    });
    setData(tableData);
  };

  useEffect(() => {
    if (props.activities?.length > 0) {
      // Data formatting for grouped filter
      if (groupedByFilter) {
        const uniqueBookingArr = [
          ...new Set(props.activities.map((element) => element.job_id)),
        ];
        const groupedFilterArray = [];
        for (const uniqueBooking of uniqueBookingArr) {
          groupedFilterArray.push({ job_id: uniqueBooking, super_row: true });
          props.activities
            .filter((item) => item.job_id === uniqueBooking)
            .forEach((element) => {
              groupedFilterArray.push(element);
            });
        }
        createTableData(groupedFilterArray);
      } else {
        createTableData(props.activities);
      }
    }
  }, [props.activities, columns]);

  return (
    <div className="space-y-1">
      <DraggableTable
        data={data}
        columns={columns}
        columnOrder={columnOrder}
        setColumnOrder={setColumnOrder}
        loader={props.loader}
        noRecords={props.activities?.length === 0}
        pageName="overview"
        isTableChange={isTableChange}
        setIsTableChange={setIsTableChange}
        ApiCallingFunction={addAndUpdateCustomizableTableChange}
      />

      {!props.loader && props.activities?.length > 0 && (
        <div className="flex justify-between items-center">
          <RowsPerPageSelector />
          <PageSelector
            rowPerPage={user.row_count}
            page={page}
            setpage={(newPage) => {
              props.onPageChange(newPage);
              setPage(newPage);
            }}
            totalDataCount={overviewData.total}
          />
        </div>
      )}

      {/* Modal for transfer activity */}
      <TransferActivityModal
        modalOpen={isTransfer}
        setModalOpen={setIsTransfer}
        my_curr_id={current_id}
        mappingid={mapping_id}
        updateTable={props.updateTable}
        setUpdateTable={props.setUpdateTable}
        activityId={activityId}
        activity_assignment_id={activity_assignment_id}
        company_id={props.company_id}
        email_id={props.email}
        isEmbedded={isEmbedded}
      />

      {/* Modal for extend activity */}
      <ExtendActivityModal
        modalOpen={isExtend}
        setModalOpen={setIsExtend}
        my_curr_id={current_id}
        my_status={status}
        mappingid={mapping_id}
        activity_id={activityId}
        activity_assignment_id={activity_assignment_id}
        updateTable={props.updateTable}
        setUpdateTable={props.setUpdateTable}
        company_id={props.company_id}
        email={props.email}
        isEmbedded={isEmbedded}
      />
    </div>
  );
};

export default RecentActivities;
